import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-rider-otp-view',
  templateUrl: './rider-otp-view.component.html',
  styleUrls: ['./rider-otp-view.component.scss']
})
export class RiderOtpViewComponent implements OnInit {
  @Input() otp:string
 
  
  startOtp:string[];
  endOtp:string[];
  showEndOtp:boolean=false
  startText:string="START OTP"
  endText:string="END OTP"

  ngOnInit(): void {
    if(this.otp){
      this.startOtp=this.otp.split(',')[0]?.split('')
      this.endOtp=this.otp.split(',')[1]?.split('')
      this.showEndOtp=this.otp.includes(',')
    }
   
  }

}
